import React from 'react';
import { Alert } from 'reactstrap';
import BoldButton from './BoldButton';
import KaAlert from './KaAlert';
import KaModal from './KaModal';
import SidePaneLayout from './SidePaneLayout';
import SpinnerButton from './SpinnerButton';
import { CenteredSpinner } from './CenteredSpinner';
import { Error } from './useFetch';
import { UseDisplayMessage } from './useDisplayMessage';

export enum ModalMode {
  Create,
  Edit,
  View,
}

export const modalMode = (canModify: boolean, isCreating: boolean) =>
  !canModify ? ModalMode.View : isCreating ? ModalMode.Create : ModalMode.Edit;

interface IProps {
  mode: ModalMode;
  entityName: string;
  displayMessage: UseDisplayMessage;
  loading?: boolean;
  loadError?: Error | null;
  renderForm: JSX.Element;
  renderSiteAssignment?: JSX.Element;
  onHide: () => void;
  isSaving: boolean;
  onSubmit: () => void;
}

const EntityModal = (props: IProps) => {
  const submitLabel = props.mode === ModalMode.Edit ? 'Update' : 'Create';
  const entityTitle = props.entityName.replace(/\b\w/g, c => c.toUpperCase());

  const footer = props.mode === ModalMode.View || props.loadError
    ? <BoldButton className="btn-ghost-primary" onClick={props.onHide}>Close</BoldButton>
    : (
      <SpinnerButton
        className="btn-ghost-primary"
        spinning={props.isSaving}
        disabled={props.loading}
        onClick={props.onSubmit}>
        {submitLabel}
      </SpinnerButton>);

  return <KaModal
    show={true}
    size={props.renderSiteAssignment ? 'lg' : undefined}
    scrollable
    bodyClassName="d-flex flex-column"
    onHide={props.onHide}
    title={`${props.mode === ModalMode.View ? 'View' : submitLabel} ${entityTitle}`}
    body={(<>
      <KaAlert displayMessage={props.displayMessage.message} onClose={props.displayMessage.clear} />
      {props.loading
        ? <CenteredSpinner />
        : props.loadError
          ? <Alert color="danger">{props.loadError.message}</Alert>
          : <fieldset disabled={props.mode === ModalMode.View} className="border-0 p-0 m-0 d-flex flex-column" style={{ minHeight: 0 }}>
            <SidePaneLayout
              paneTitle="Assigned Sites"
              pane={props.renderSiteAssignment}>
              {props.renderForm}
            </SidePaneLayout>
          </fieldset>}
    </>)}
    footer={footer}
  />;
};

export default EntityModal;
